import Api from "@nextories/vue-tasks/src/utils/Api";

export default class AppApi extends Api {
  /**
   * Retrieve the project of the current user from the backend
   * @returns {Promise<Object>} resolve with the project for the current user
   * or reject with the backend error message
   */
  getSearchProjects(query: string): Promise<any> {
    return this._nxtGetData(`/n2/search-demenagement${query ? `?${query}` : ''}`);
  }

  getDiary(request: {}): Promise<any> {
    return this._nxtPostData('/n2/list-calls-calendar', request);
  }

  getCountTasks(request: {}): Promise<any> {
    request.count_tasks = true;
    return this._nxtPostData('/n2/list-calls', request);
  }

  getProjects(request: {}): Promise<any> {
    return this._nxtPostData('/n2/list-dgts', request);
  }

  getProject(): Promise<any> {
    return this._nxtGetData(`/n2/calls/project/${this.projectToken}`);
  }

  getListTasksType(): Promise<any> {
    return this._nxtGetData('/n2/list-tasks-type');
  }

  getTasks(request: {}): Promise<any> {
    return this._nxtPostData('/n2/list-calls', request);
  }

  postUpdateMultitasks(request: {}): Promise<any> {
    return this._nxtPostData('/n2/update-multicalls', request);
  }

  postTask(request: {}): Promise<any> {
    return this._nxtPostData('/n2/update-call', request);
  }

  updateTask(request: {}): Promise<any> {
    return this._nxtPostData('/n2/update-call', request);
  }

  deleteTask(id: string): Promise<any> {
    return this._nxtPostData(`/n2/delete-call/${id}`);
  }
}
